import React, { Fragment, useMemo, useState } from "react";
import { TextField, MaskedTextField,  } from '@fluentui/react/lib/TextField';
import { mergeStyleSets, PrimaryButton } from "@fluentui/react";

interface DefaultSelectorProps {
    id: string;
    value: any;
    multiline?: boolean;
    onChange: (styleElementName: string, value: any) => void;
    defaultValue?: any;
}

const classNames = mergeStyleSets({
    textarea: {
        outline: 'none',
        ':hover': {
            border: `2px solid red`,

        }
    },
    addDefaultTemplateButton: {
        display: 'flex',
        marginTop: 5,
        marginLeft: 'auto'
        // float: 'right'
    }
});

export const DefaultSelector = (props: DefaultSelectorProps) => {
    const { id, value, onChange, defaultValue } = props;

    const [reactValue, setReactValue] = useState(value);

    const parsedValue = useMemo(() => {
        if(reactValue && typeof reactValue === "object") {
            try {
                return JSON.stringify(reactValue, null, 2);
            } catch {
                return reactValue;
            }
        }   
        return reactValue;
    }, [reactValue]);
    return (
        <Fragment>
            <TextField multiline={props.multiline}
             value={parsedValue}
             defaultValue={parsedValue}
             onChange={(e: any) => setReactValue(e.target.value)}
             onBlur={(e: any) => {
                let newValue = e.target.value;
                if(newValue && /^\d+$/.test(newValue)) {
                    newValue = parseInt(newValue);
                }
                onChange(id, newValue);
                }}/>

            {defaultValue && <PrimaryButton className={classNames.addDefaultTemplateButton} text="Add default template" onClick={() => { onChange(id, defaultValue); setReactValue(defaultValue) }} />}
        </Fragment>
    );
}